export default __webpack_public_path__ + "static/media/kh.a86d5121.svg";